import React, { useState } from "react";
import queryString from "query-string";

import Form from "../components/Form";
import illustrationSuccess from "./illustration_success.svg";
import illustrationError from "./illustration_error.svg";
import { useTranslation } from "react-i18next";

const ResetPassword = () => {
  const [formDone, setFormDone] = useState(false);
  const [tokenExpired, setTokenExpired] = useState(false);
  const { t } = useTranslation();

  const parsed = queryString.parse(window.location.search);
  const token = parsed.token;

  const ContactSection = () => (
    <p
      style={{
        fontSize: "18px",
        color: "#2b3136",
        textAlign: "center",
        lineHeight: "1.6",
      }}
    >
      {t("contact_company.body0")}
      <br />
      {t("contact_company.body1")}
      <br />
      {t("contact_company.body2")}
      <br />
      <br />
      <a
        href="/privacy-policy"
        target="_blank"
        rel="noopener noreferrer"
      >
        服務條款
      </a>
      <br />
    </p>
  );

  if (tokenExpired) {
    return (
      <div className="content">
        <img
          src={illustrationError}
          className="illustration-icon"
          alt={t("fail")}
        />
        <h1 style={{ fontSize: "36px", fontWeight: 600, color: "#4d4d4d" }}>
          {t("change_password.expired.title")}
        </h1>
        <p style={{ fontSize: "18px", color: "#2b3136", textAlign: "center" }}>
          {t("change_password.expired.body")}
        </p>
      </div>
    );
  }

  if (formDone) {
    return (
      <div className="content">
        <h1 style={{ fontSize: "36px", fontWeight: 600, color: "#4d4d4d" }}>
          {t("change_password.success.title")}
        </h1>
        <p style={{ fontSize: "18px", color: "#2b3136", textAlign: "center" }}>
          {t("change_password.success.body.1")}
        </p>
        <img
          src={illustrationSuccess}
          className="illustration-icon"
          alt={t("success")}
        />
        <ContactSection />
      </div>
    );
  }

  return (
    <div className="content">
      <h1 style={{ fontSize: "36px", fontWeight: 600, color: "#4d4d4d" }}>
        {t("change_password.fail.title")}
      </h1>
      <Form
        token={token}
        setFormDone={setFormDone}
        setTokenExpired={setTokenExpired}
      />
      <ContactSection />
    </div>
  );
};

export default ResetPassword;
